import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Alert,
} from "@mui/material";
import { useAuth } from "../contexts/AuthContext";

const SuggestUpdateModal = ({ open, onClose, divesiteId }) => {
  const { userObjectId, currentUser } = useAuth();
  const [suggestion, setSuggestion] = React.useState("");
  const [error, setError] = React.useState(null);
  const [success, setSuccess] = React.useState(null);
  const [submissionSuccessful, setSubmissionSuccessful] = React.useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!suggestion) {
      setError("Please enter a suggestion");
      return;
    }

    try {
      const token = await currentUser.getIdToken();

      const response = await fetch(
        `/api/suggestions/suggest-update`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            divesiteId,
            suggestion,
            suggester: userObjectId,
          }),
        }
      );

      const data = await response.json();

      if (data.success) {
        setSuccess("Suggestion submitted successfully");
        setError(null);
        setSuggestion("");
        setSubmissionSuccessful(true);
      } else {
        setError(data.error || "Failed to submit suggestion");
        setSuccess(null);
        setSubmissionSuccessful(false);
      }
    } catch (err) {
      console.error("Error submitting suggestion:", err);
      setError("Error submitting suggestion");
      setSuccess(null);
      setSubmissionSuccessful(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Suggest an Update</DialogTitle>
      <DialogContent>
        {error && <Alert severity="error">{error}</Alert>}
        {success && <Alert severity="success">{success}</Alert>}
        <TextField
          label="Your suggestion"
          multiline
          rows={4}
          fullWidth
          margin="normal"
          value={suggestion}
          onChange={(event) => setSuggestion(event.target.value)}
          disabled={submissionSuccessful}
        />
      </DialogContent>
      <DialogActions>
        {submissionSuccessful ? (
          <Button onClick={onClose} color="primary">
            Close
          </Button>
        ) : (
          <>
            <Button onClick={onClose}>Cancel</Button>
            <Button onClick={handleSubmit} color="primary">
              Submit
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default SuggestUpdateModal;
